import { usePlanogramQuery } from "@/shared/api";
import { useSchedules } from "./useSchedules";

export function usePlanogram() {
  const { activeSchedule: planogramActiveSchedule } = useSchedules({
    queryKey: "planogramSchedules",
  });
  const { planogram } = usePlanogramQuery(
    {
      id: planogramActiveSchedule?.id ?? 0,
    },
    {
      skip: !planogramActiveSchedule,
      selectFromResult: (result) => ({
        planogram: result.data?.result,
      }),
    }
  );

  return { planogram, planogramActiveSchedule };
}
